import { environment } from 'services/environment/Environment';
import { getAccessToken } from 'store/state';

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

interface ApiClientOptions<T> {
  method: Method;
  url: string;
  body?: T;
  params?: Record<string, any>;
  withContentType?: boolean;
  customContentType?: string;
  customHeaders?: Record<string, string>;
  withoutVersion?: boolean;
}

const apiClient = async <T>({
  method,
  url,
  body,
  params,
  withContentType = true,
  customContentType,
  withoutVersion = false,
  customHeaders = {}
}: ApiClientOptions<T>) => {
  const token = getAccessToken();
  const baseURL = environment().api.apiUrl;

  let fullUrl = (withoutVersion ? baseURL.replace('v1/', '') : baseURL) + url;

  if (params) {
    const queryParams = new URLSearchParams(params).toString();
    fullUrl += `?${queryParams}`;
  }

  const headers = {
    Accept: '*/*',
    Authorization: `Bearer ${token}`,
    ...customHeaders,
  };

  const requestOptions: RequestInit = {
    method,
    headers: withContentType
      ? {
          'Content-Type': customContentType ?? 'application/json',
          ...headers,
        }
      : headers,
    body:
      !withContentType || !!customContentType?.length
        ? (body as any)
        : JSON.stringify(body),
  };

  const response = await fetch(fullUrl, requestOptions);
  return response;
};

export default apiClient;
